import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-page-header-view-navigation',
  templateUrl: './page-header-view-navigation.component.html',
  styleUrl: './page-header-view-navigation.component.scss',
  imports: [Button, MatIcon, MatProgressBar, Card],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderViewNavigation {
  readonly progress = input<number>(0);

  readonly displayProgress = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isFirst = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isLast = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly nextDisabled = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly previousDisabled = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly finishDisabled = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly canFinish = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly previousPressed = output<void>();
  readonly nextPressed = output<void>();
  readonly finishPressed = output<void>();
}
